/**
 * Feature gates fail closed: only an explicit tenant entitlement enables a feature.
 */
export function isTenantFeatureEnabled(
  features: Record<string, boolean>,
  key: string,
): boolean {
  return features[key] === true;
}
